/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React from 'react';
import { SupportedLocales } from '../localization';

export type openModuleProps = {
  widget:
    | 'flights'
    | 'flight_deeplink'
    | 'hotels'
    | 'hotel_deeplink'
    | 'snap_deeplink';
  deeplink?: string;
};

export type backHandlerProps = {
  goBackToSuperApp: boolean;
};

const SuperAppContext = React.createContext<{
  backHandler: (params?: backHandlerProps) => void;
  currency: string;
  deeplink?: string;
  openModule: (data: openModuleProps) => void;
  locale: SupportedLocales;
  geoId?: string;
}>({
  openModule: ({ widget, deeplink }) => {
    console.log(
      'superAppNavigation called: widget',
      widget,
      ' deeplink: ',
      deeplink,
    );
  },
  backHandler: (params) => {
    console.log('Backhandler called with params: ', params);
  },
  currency: 'MYR',
  deeplink: '',
  locale: 'en-gb',
  geoId: 'MY',
});

export default SuperAppContext;
